import { render, staticRenderFns } from "./WorkShiftListComponent.vue?vue&type=template&id=92395990&"
import script from "./WorkShiftListComponent.vue?vue&type=script&lang=js&"
export * from "./WorkShiftListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports